import React from 'react'
import { BrowserRouter,NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import Doke from './components/doke/scRNA';
const Home = () => <h1>Human Kidney Single Cell Transcriptome</h1>;
function App() {
  return (
	  Doke()
  );
}
export default App;
